import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default, { useContext } from 'react';
import { SideNavContext } from './index.js';

var _excluded = ["as", "className"];
var SideNavSkipLink = function SideNavSkipLink(_ref) {
  var _ref$as = _ref.as,
    As = _ref$as === void 0 ? 'a' : _ref$as,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var parentContext = useContext(SideNavContext);
  var finalClasses = classnames('C-SideNav__SkipLink', className);

  // do not return the skiplink component on iconsOnly sidenavs
  if (parentContext !== null && parentContext !== void 0 && parentContext.isMinimized) {
    return null;
  } else {
    return /*#__PURE__*/React__default.createElement(As, _extends({
      className: finalClasses
    }, otherProps));
  }
};
SideNavSkipLink.displayName = 'SideNav.SkipLink';

export { SideNavSkipLink as default };
